
import { OK } from 'http-status-codes'
import getAxiosInstance from '../../../helpers/get_axios_instance'

export class TablaDetalleEspacioPorCerealLinea5Service {
  static async getDataTablaDetalleEspacioPorCerealLinea5 () {
    const axios = getAxiosInstance()
    const promise = axios.get('/consulta_espacio_cereal_sector5')
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el reporte de tabla Espacio por cereal sector 5.')
      return (data)
    })
  }

  static async getDataTablaDetalleEspacioPorCerealLinea5Total () {
    const axios = getAxiosInstance()
    const promise = axios.get('/consulta_espacio_cereal_sector5_total')
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el reporte de tabla Espacio por cereal sector 5.')
      return (data)
    })
  }
}
